
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill-rule":"evenodd","clip-rule":"evenodd"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.533 14.322l-.061.678h4.304A9.028 9.028 0 0021 13l-.004-.243.987-1.56.649-1.024c.24.902.368 1.85.368 2.827 0 6.071-4.929 11-11 11-2.642 0-5.067-.933-6.964-2.487A4.52 4.52 0 006.6 20.199a8.982 8.982 0 003.013 1.481l-.084-.16a19.07 19.07 0 01-1.336-3.265l-.061-.208 1.847-.819c.081.299.171.596.27.891A17.281 17.281 0 0012 21.815c.246-.399.48-.804.696-1.219A17.02 17.02 0 0014.081 17h-3.587l6.039-2.678zM20.063 17h-3.926a18.072 18.072 0 01-.489 1.753 19.223 19.223 0 01-1.262 2.927A9.033 9.033 0 0020.063 17zm-.814-7.711c-1.521-2.411-2.583-4.232-2.583-5.805C16.666 1.56 18.409 0 20.333 0 22.258 0 24 1.56 24 3.484S22.41 7.705 20.333 11l-.002-.003-14.332 6.355.001.074a3.001 3.001 0 11-3-3c.914 0 1.733.41 2.283 1.055l13.966-6.192zM3.223 11A9.01 9.01 0 003 12.936V13c-.715 0-1.391.167-1.991.464L1 13C1 6.929 5.929 2 12 2c1.139 0 2.238.174 3.272.496a4.739 4.739 0 00-.089.593 5.317 5.317 0 00.105 1.532 8.98 8.98 0 00-.935-.31l.183.359a19.844 19.844 0 011.39 3.618l.186.75L11.716 11H9.561c-.044.332-.078.666-.101 1l-2.037.903c.007-.636.048-1.271.122-1.903H3.223zm6.423-6.689A9.035 9.035 0 003.936 9h3.958c.094-.408.202-.812.324-1.213a20.114 20.114 0 011.428-3.476zm2.353-.104c-.265.443-.516.894-.746 1.356a17.78 17.78 0 00-1.25 3.253L9.953 9h4.093a18.2 18.2 0 00-2.047-4.793zm8.334.835a1.376 1.376 0 11.001-2.751 1.376 1.376 0 01-.001 2.751z"}})])
          )
        }
      }
    